<template>
	<nav
		v-if="!brandBuilder || expandedMenu"
		class="lg-side-nav"
		aria-label="Main"
		:class="{ expanded: expandedMenu, expandedSmallNav: expandedSmallNav }"
	>
		<ProfileSwitcherWidget />
		<ProfileSelectorWrapper />
		<LgExpandingNavItem
			v-for="(menuItem, index) in menuItems"
			:key="index"
			:iconWeight="menuItem.iconWeight"
			:icon="menuItem.icon"
			:name="menuItem.name"
			:route="menuItem.route"
			:meta="menuItem.meta"
		/>

		<button
			class="caret"
			aria-label="collapse expand menu"
			@click="toggleExpandedMenu()"
		>
			<span v-if="expandedMenu">
				<font-awesome-icon :icon="['fas', 'caret-left']" />
			</span>
			<span v-else>
				<font-awesome-icon :icon="['fas', 'caret-right']" />
			</span>
		</button>
	</nav>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ProfileSwitcherWidget from './ProfileSwitcherWidget.vue';
import ProfileSelectorWrapper from './ProfileSelectorWrapper.vue';
import LgExpandingNavItem from './LgExpandingNavItem.vue';

export default {
	name: 'LgExpandingNav',
	components: {
		LgExpandingNavItem,
		ProfileSwitcherWidget,
		ProfileSelectorWrapper,
	},
	props: {
		msg: String,
		brandBuilder: Boolean,
	},
	computed: {
		...mapGetters(['canAccessBoost']),
		...mapState({
			expandedMenu: (state) => state.menus.expandedMenu,
			expandedSmallNav: (state) => state.menus.expandedSmallNav,
			hasSocialVAccount: (state) => state.profile.hasSocialVAccount,
			userInPilot: (state) => state.profile.isPilotUser,
		}),
		menuItems() {
			const excludedRoutes = ['Dashboard', 'Client Connect', 'Feedback'];
			const filteredRoutes = this.$router.options.routes.filter((route) => {
				if (route.hasOwnProperty('meta')) {
					if (route.meta.hasOwnProperty('menuData')) {
						if (this.userInPilot) {
							if (excludedRoutes.includes(route.name)) {
								return;
							}
							if (
								route.name === 'Video Reviews' &&
								this.hasSocialVAccount !== route.meta.hasSocialVAccount
							) {
								return;
							}
							return route;
						} else {
							if (
								route.name === 'Video Reviews' &&
								this.hasSocialVAccount !== route.meta.hasSocialVAccount
							) {
								return;
							}
							if (route.name === 'Boost' && this.canAccessBoost) {
								return route;
							}
							if (route.name === 'Marketing Resources') {
								return;
							}
							return route;
						}
					}
				}
			});
			return filteredRoutes.map((r) => ({
				name: r.name,
				route: r.path,
				iconWeight: r.meta.menuData.iconWeight,
				icon: r.meta.menuData.icon,
				meta: r.meta,
				availableWithInvalidPreferences: r.meta.menuData.hasOwnProperty(
					'availableWithInvalidPreferences',
				)
					? r.meta.menuData.availableWithInvalidPreferences
					: false,
				disabled: r.meta.menuData.hasOwnProperty('disabled')
					? r.meta.menuData.disabled
					: false,
			}));
		},
	},
	methods: mapActions(['toggleExpandedMenu']),
};
</script>

<style scoped lang="scss">
.expanded {
	@include lg {
		width: $expanded-menu-width !important;
	}
}

.lg-side-nav {
	top: $top-nav-height;
	position: fixed;
	z-index: 13;
	height: calc(
		100vh - (#{$top-nav-height} + #{$b360-border-width-thin})
	); /* Please do not remove this fixes the scrolling of the nav which accounts for the header height 81px. */
	overflow-y: scroll;
	overflow-x: hidden;
	background-color: $white;
	border-top: $border-width solid $border-color-light;
	border-right: $border-width solid $border-color-light;
	width: $collapsed-menu-width;

	&::-webkit-scrollbar {
		display: none;
	}

	&.expandedSmallNav {
		@include sm {
			display: block;
			position: relative;
			height: 100%;
			width: 100%;
		}

		.caret {
			display: none;
		}
	}
}

.caret {
	span {
		margin: 0;
	}

	color: $brand-blue;
	text-align: center;
	cursor: pointer;
	user-select: none;
	position: absolute;
	width: 100%;
	margin-top: 20px;
	@include rem(font-size, 22px);
	background-color: transparent;
	border: unset;

	&:hover {
		color: lighten($brand-blue, 20%);
	}
}
</style>
